import { useEffect, useState } from "react";
import { collection, query, onSnapshot, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { tryResolveTenantId } from "../utils/tenant";

export function useDepartments() {
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    let isActive = true;
    let unsubscribe = () => {}; // always a function, avoids null races

    const start = async () => {
      try {
        const tenantId = await tryResolveTenantId();

        // If the component unmounted while we were awaiting, bail.
        if (!isActive) return;

        if (!tenantId) {
          setDepartments([]);
          return;
        }

        const q = query(
          collection(db, `tenants/${tenantId}/departments`),
          orderBy("name")
        );

        unsubscribe = onSnapshot(
          q,
          (snap) => {
            if (!isActive) return;

            const next = snap.docs
              .map((d) => ({ id: d.id, ...d.data() }))
              .filter((d) => !d.archived);

            setDepartments(next);
          },
          (err) => {
            // Don't crash UI; just log and keep last known state
            console.error("useDepartments onSnapshot error:", err);
          }
        );
      } catch (err) {
        console.error("useDepartments failed to initialize:", err);
        if (isActive) setDepartments([]);
      }
    };

    start();

    return () => {
      isActive = false;
      unsubscribe(); // always safe to call
    };
  }, []);

  return departments;
}
